<template>
  <v-sheet outlined class="px-2 px-md-7">
    <v-container class="my-8">
      <v-row class="w--100">
        <v-col cols="12" md="8">
          <span class="mb-2 fieldset-title"
            >دسته بندی کالای مورد نظر را ثبت کنید.</span
          >
        </v-col>
        <v-col cols="12" sm="8">
          <v-select
            label="نوع فعالیت"
            outlined
            persistent-hint
            item-text="displayName"
            item-value="title"
            dense
            required
            return-object
            :menu-props="{
              closeOnClick: true,
              closeOnContentClick: true,
            }"
            readonly
            v-model="merchantCategoryTypes"
            :items="actvieList"
            @change="getCategoriesTreeList"
            hide-details
          />
        </v-col>
      </v-row>
      <template v-if="activeSelectedItem && activeSelectedItem.activeTreeItem">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              label="جستجو"
              outlined
              dense
              type="text"
              required
              v-model="searchTreeList"
              append-icon="mdi-magnify"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <span class="blue--text text--darken-5">{{
                  activeSelectedItem.item.displayName
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-treeview
                  :ref="`treeView${activeSelectedItem.item.title}`"
                  item-text="name"
                  item-key="id"
                  item-children="subcategories"
                  :items="activeSelectedItem.treeList"
                  :search="searchTreeList"
                  color="primary"
                  transition
                  :open.sync="activeSelectedItem.openTreeItem"
                  return-object
                >
                  <template v-slot:label="props">
                    <div class="treeCheckBox">
                      <v-checkbox
                        v-if="props.item.isLeaf"
                        v-model="activeSelectedItem.activeTreeItem"
                        class="mt-0"
                        hide-details
                        :value="props.item"
                        :label="props.item.name"
                        small
                        dense
                        :ripple="false"
                        @change="selectTree"
                      >
                      </v-checkbox>
                      <span v-else class="f-s-13 text-right">{{
                        props.item.name
                      }}</span>
                    </div>
                  </template>
                </v-treeview>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-row ref="tables" class="mt-5" v-if="merchantCategoriesList.length">
        <v-col cols="12">
      
          <MerchantCategoryComponentVue
            v-if="
              merchantCategoryTypes == 'ConsultingService' ||
              merchantCategoryTypes == 'ElectronicDocument' ||
              merchantCategoryTypes == 'IndustrialService'
            "
            @changeProcessType="changeProcessType"
            :items="merchantCategoriesList"
            :merchantCategoryTypes="merchantCategoryTypes"
            :fields="
              merchantCategoryTypes == 'IndustrialService'
                ? merchantCategoryFieldsIndustrialService
                : merchantCategoryFields
            "
            @removeFromList="removeMerchantCategoriesList"
          />
          <SupplierProductInformation
            v-else-if="merchantCategoryTypes == 'Product'"
            :isSelectedProduct="isSelectedProduct"
            :selectedForEdit="selectedForEdit"
            :measurementFlag="measurementFlag"
            :properties="selectedProduct.properties"
            :breadCrumb="breadCrumb"
            @completeProductProperties="completeProductProperties"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const categoryRepository = () => RepoFactory.get('category');
const supplierProductRepository = () => RepoFactory.get('supplierProduct');
const measurementQuantitiesRepository = () =>
  RepoFactory.get('measurementQuantities');
import MerchantCategoryComponentVue from './MerchantCategoryComponent.vue';
import SupplierProductInformation from './SupplierProductInformation.vue';

export default {
  props: {
    resetTree: {
      type: Boolean,
      default: false,
    },
    closeStepper: {
      type: Boolean,
    },
    techInfos: {
      type: Array,
      default: [],
    },
    setTechInfo: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    MerchantCategoryComponentVue,
    SupplierProductInformation,
  },
  data() {
    return {
      breadCrumb:'',
      otherBranch: false,
      // techInfos:[],
      tableEditItems: [],
      SaveBtn: false,
      measurementFlag: false,
      selectedForEdit: [],
      categoryIds: [],
      processType: [],
      product: {},
      selectedProduct: {
        productId: null,
        categoryId: null,
        name: null,
        summary: null,
        description: null,
        imagesFileIds: [],
        properties: [],
        countingUnit: null,
        taxed: false,
      },
      isSelectedProduct: false,
      editFlag: false,
      merchantCategoryTypes: [],
      merchantCategoriesList: [],
      merchantCategoryFieldsIndustrialService: [
        {
          value: 'breadcrumb',
          text: 'عنوان فرایند ',
          sortable: false,
        },

        {
          value: 'productionProcessType',
          text: 'نوع فرایند ',
        },
        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],
      actvieList: [],
      activeSelectedItem: null,
      searchTreeList: null,
      selectionItems: [],
      activeTreeItem: [],
      form: {
        categoryIds: null,
        categoryTypes: [],
      },
    };
  },
  computed: {
    checkIfSelectedTreeNode() {
      return (
        this.selectionItems.length &&
        this.selectionItems.find((el) => el.activeTreeItem.length)
      );
    },
    closeStepperProp: {
      get() {
        return this.closeStepper;
      },
      set(val) {
        this.$emit('changeCloseStepper', val);
      },
    },
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
  },
  methods: {
    completeProductProperties(product) {
      this.product.properties = [];
      this.product.properties = product.properties;
      // this.product.properties = properties;

      this.$emit(
        'getTradeRequestItemPropertyValues',
        this.product.properties,
        this.form.categoryIds
      );
      this.SaveBtn = true;
    },
    selectProductForAddingNewSupplierProduct(categoryId) {
      const loader = this.$loading.show();
      supplierProductRepository()
        .getProductAllProperties(categoryId, this.productBaseUrl)
        .then((response) => {
          let tempProductProperties = [];
          response.data.forEach((element) => {
            element.propertyId = element && element.id ? element.id : '';
            element.measurementUnitId =
              element && element.id ? element.defaultMeasurementUnitId : null;
            element.measurementUnitItem = [];
            if (element.measurementQuantityId) {
              // element.measurementUnitItem = element.units;
              measurementQuantitiesRepository()
                .getMeasurementQuantityActiveUnits(
                  element.measurementQuantityId,
                  this.productBaseUrl
                )
                .then((res) => {
                  element.measurementUnitItem = res.data;
                  // tempProductProperties.push(element);
                })
                .catch((error) => {
                  loader.hide();
                  Helper.handleErrors(error, this);
                });
            }
            if (
              !this.otherBranch &&
              this.$store.getters.tradeRequestSelectedForDisplay &&
              this.$store.getters.tradeRequestSelectedForDisplay.id.length
            ) {
              this.techInfos[0].tradeRequestItemPropertyValues.forEach(
                (selectedProperty) => {
                  if (selectedProperty.categoryPropertyId == element.id) {
                    element.id = selectedProperty.id;
                    element.value =
                      element.propertyType == 'MultiSelectList'
                        ? selectedProperty.value.split('|')
                        : selectedProperty.value;
                    element.measurementUnitId =
                      selectedProperty.measurementUnitId;
                    // element.maxValue= selectedProperty.maxValue
                    // element.setMaxValue= selectedProperty.maxValue? true: false
                  }
                }
              );
            }
            tempProductProperties.push(element);
          });
          this.selectedProduct.properties = [];
          this.selectedProduct.properties = tempProductProperties;
          

          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    changeProcessType(item, items) {
      this.$emit('getCategoriesList', items);
    },
    selectedActivitiesTypes() {
      if (this.form.categoryTypes.length) {
        return this.actvieList.filter((el) =>
          this.form.categoryTypes.includes(el.title)
        );
      } else {
        return [];
      }
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.actvieList = data;
            resolve();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      });
    },
    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};

      // param.categoryTypes = val.map((el) => el.title);
      param.categoryTypes = val;
      categoryRepository()
        .getCategoriesList(this.$store.getters.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getMerchantCategoriesByIds() {
      let app = this
      let ids = [];
      if (app.editFlag) {
        app.form.categoryIds = [];
        app.form.categoryIds = app.categoryIds;
      } else {
        if (app.activeSelectedItem && app.activeSelectedItem.activeTreeItem) {
          ids = app.activeSelectedItem.activeTreeItem.map((el) => {
            return el.id;
          });
        }
        if (
          app.form.categoryIds == undefined ||
          app.form.categoryIds == null
        ) {
          app.form.categoryIds = [];
        }
        app.form.categoryIds = ids;
      }
      if (
        app.merchantCategoryTypes != 'IndustrialService' &&
        typeof app.merchantCategoryTypes == 'string'
      ) {
        app.form.categoryIds = [
          app.form.categoryIds[app.form.categoryIds.length - 1],
        ];
      }
      if (app.merchantCategoryTypes == 'Product') {
        app.selectProductForAddingNewSupplierProduct(app.form.categoryIds[0]);
      }
      const params = {
        ids: app.form.categoryIds.join(','),
      };
      const loader = this.$loading.show()
      categoryRepository()
        .getMerchantCategoriesByIds(this.$store.getters.productBaseUrl, params)
        .then((res) => {
          
           if (app.merchantCategoryTypes == 'IndustrialService') {
           res.data.forEach(x=>{
              app.merchantCategoriesList.push({
              productionProcessType: x.productionProcessType,
              mainCategoryTitle: x.mainCategoryTitle,
              breadcrumb: x.breadcrumb,
              techInfoId: null,
              productCategoryId: x.categoryId,
            });
            })
            const key = 'productCategoryId';
            app.merchantCategoriesList = [...new Map(app.merchantCategoriesList.map(item =>
              [item[key], item])).values()];
           
            
          }
         
          else{
            app.merchantCategoriesList = res.data;
            app.breadCrumb = res.data[0].breadcrumb
          }
          app.activeSelectedItem.activeTreeItem.forEach((el) => {
            if (!app.form.categoryTypes.includes(el.categoryType)) {
              app.form.categoryTypes.push(el.categoryType);
            }
          });
          loader.hide()
        })
         .catch(err=>{
            Helper.handleErrors(err, this);
            loader.hide()
        })
    },
    selectTree(val) {
      this.editFlag = false;
      this.otherBranch = true;
      if (this.merchantCategoryTypes != 'IndustrialService') {
        this.activeSelectedItem.activeTreeItem = [
          this.activeSelectedItem.activeTreeItem[
            this.activeSelectedItem.activeTreeItem.length - 1
          ],
        ];
      }
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      } else {
        this.merchantCategoriesList = [];
        this.form.categoryIds = [];
      }
    },
    deSelectTree() {
      this.selectionItems.forEach((element) => {
        element.activeTreeItem = [];
      });
    },
    removeMerchantCategoriesList(item) {
      let mcl=[]
      this.merchantCategoriesList = this.merchantCategoriesList.forEach((el) => {
        if (
          el.techInfoId &&
          el.techInfoId.length &&
          item.techInfoId &&
          item.techInfoId.length
        ) {
          
          if(el.techInfoId !== item.techInfoId){
            mcl.push(el)
            
          }
        } else if (
          el.productCategoryId &&
          el.productCategoryId.length &&
          item.productCategoryId &&
          item.productCategoryId.length
        ) {
          
          if(el.productCategoryId !== item.productCategoryId){
             mcl.push(el)
             
          }
        } else if (
          el.categoryId &&
          el.categoryId.length &&
          item.categoryId &&
          item.categoryId.length
        ) {
          

          if(el.categoryId !== item.categoryId){
            mcl.push(el)
            
          }
        }
      });
      this.merchantCategoriesList = mcl
      
      this.form.categoryIds = this.form.categoryIds.filter((el) => {
        if (item.categoryId && item.categoryId.length) {
          el !== item.categoryId;
        } else if (item.productCategoryId && item.productCategoryId.length) {
          el !== item.productCategoryId;
        }
      });
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter((el) => {
          if (item.categoryId && item.categoryId.length) {
            el !== item.categoryId;
          } else if (item.productCategoryId && item.productCategoryId.length) {
            el !== item.productCategoryId;
          }
        });
      // const categoryTypeTitle = item.categoryTypeTitle;
      // if (
      //   !this.merchantCategoriesList.find(
      //     (el) => el.categoryTypeTitle == categoryTypeTitle
      //   )
      // ) {
      //   this.form.categoryTypes.splice(
      //     this.form.categoryTypes.indexOf(categoryTypeTitle),
      //     1
      //   );
      //   this.merchantCategoryTypes.splice(
      //     this.form.categoryTypes.indexOf(
      //       (el) => el.title == categoryTypeTitle
      //     ),
      //     1
      //   );
      // }
    },
    async fillTechInfos() {
      if (this.techInfos && this.techInfos.length) {
        if (this.merchantCategoryTypes != 'Product') {
          this.editFlag = true;
          let ids = [];
          this.techInfos.forEach((x) => {
            ids.push(x.productCategoryId);
            this.processType.push(x.processType);
            if (this.merchantCategoryTypes == 'IndustrialService') {
              this.merchantCategoriesList.push({
                breadcrumb: x.breadcrumb.breadcrumb,
                productionProcessType: x.processType,
                categoryId: x.productCategoryId,
              });
            }
          });
          this.categoryIds = ids;
          if (this.merchantCategoryTypes != 'IndustrialService') {
            this.getMerchantCategoriesByIds();
          }
        } else if (this.merchantCategoryTypes == 'Product' && !this.SaveBtn) {
          this.editFlag = true;
          this.selectedForEdit = [];
          this.categoryIds.push(this.techInfos[0].productCategoryId);

          // await this.selectProductForAddingNewSupplierProduct(this.categoryIds[0]);

          this.getMerchantCategoriesByIds();
          setTimeout(() => {
            this.selectedForEdit =
              this.techInfos[0].tradeRequestItemPropertyValues;
            this.isSelectedProduct = true;
          }, 1000);
        }
      }
    },
  },

  watch: {
    merchantCategoriesList() {
      if (this.merchantCategoryTypes != 'Product') {
        this.$emit('getCategoriesList', this.merchantCategoriesList);
      }
    },

    // techInfos() {
    //       console.log('techInfoooo');

    //   if (
    //     this.techInfos &&
    //     this.techInfos.length
    //   ) {
    //     if (this.merchantCategoryTypes != 'Product') {
    //       this.editFlag = true;
    //       let ids = [];
    //       this.techInfos.forEach((x) => {
    //         ids.push(x.productCategoryId);
    //         this.processType.push(x.processType);
    //         if (this.merchantCategoryTypes == 'IndustrialService') {
    //           this.merchantCategoriesList.push({
    //             breadcrumb: x.breadcrumb.breadcrumb,
    //             productionProcessType: x.processType,
    //             categoryId: x.productCategoryId,
    //           });
    //         }
    //       });
    //       this.categoryIds = ids;
    //       if (this.merchantCategoryTypes != 'IndustrialService') {
    //         this.getMerchantCategoriesByIds();
    //       }
    //     }
    //      else if (this.merchantCategoryTypes == 'Product' && !this.SaveBtn) {
    //       this.editFlag = true;
    //       this.selectedForEdit = [];
    //       this.categoryIds.push(this.techInfos[0].productCategoryId);
    //       
    //     this.selectProductForAddingNewSupplierProduct(this.categoryIds[0]);

    //       // this.getMerchantCategoriesByIds();
    //       this.selectedForEdit =
    //         this.techInfos[0].tradeRequestItemPropertyValues;
    //       this.isSelectedProduct = true;
    //     }
    //   }
    // },
    //  setTechInfo(after, before){
    //   console.log('fffff');
    //   if(after && !before){
    //     this.fillTechInfos()
    //   }
    //  }
  },
  created() {
    this.getCategoryTypeItems();
    this.merchantCategoryTypes =
      this.$store.getters.tradeRequestSelectedForDisplay.category;
    this.getCategoriesTreeList(this.merchantCategoryTypes);
    if (this.merchantCategoryTypes != 'Product') {
      this.form.categoryIds =[]
      this.techInfos.forEach((x) => {
        this.merchantCategoriesList.push({
          productionProcessType: x.processType,
          mainCategoryTitle: x.breadcrumb.mainCategoryTitle,
          breadcrumb: x.breadcrumb.breadcrumb,
          techInfoId: x.id,
          productCategoryId: x.productCategoryId,
        });
        
        this.form.categoryIds.push(x.productCategoryId)
      });
      
      // this.merchantCategoriesList = this.techInfos
    } else {
      if (this.setTechInfo) {
        this.fillTechInfos();
      }
    }
  },
};
</script>

<style></style>
